// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-white/banner-mid-page-white.component.scss
// module id = 143
// module chunks = 0